import React, { Fragment } from "react";
import GTCNewsFullImage from "src/gtcnews/GTCNewsFullImage";

const Radiologist = () => {
  return (
    <Fragment>
      <GTCNewsFullImage />
    </Fragment>
  );
};

export default Radiologist;
